<!--
 * @Description: 线上测试 - 免费趣味测试（移动端）
-->
<template>
	<section class="free-fun-test-section">
		<h2 class="free-fun-test-section__title">{{ title }}</h2>
		<ul class="free-fun-test-section__grid">
			<li
				v-for="item in displayList"
				:key="item.key"
				class="free-fun-test-section__item"
				@click="handleItem(item)"
			>
				<van-image class="cover" :src="item.cover" />
				<p class="name">{{ item.title }}</p>
			</li>
		</ul>
	</section>
</template>

<script setup>
import { computed } from "vue";
import { getMentalList } from "~/api/api";
import { goLink } from "~/utils/common";

defineProps({
	title: {
		type: String,
		default: "免費趣味測試",
	},
});

const REN_SHENG_K_X_COVER =
	"https://img-fe.seersecret.com/image/a35475c2e83d5900be616dc8af0341a8-512x512.png";

const { data: mentalData } = await useLazyAsyncData(
	"onlinecs-m-free-fun-test",
	async () => {
		try {
			const res = await getMentalList();
			return res.data;
		} catch (error) {
			console.error("加载趣味測試列表失败:", error);
			return [];
		}
	},
	{
		default: () => [],
	}
);

const displayList = computed(() => {
	const head = [
		{
			key: "static-ren-sheng-kx",
			title: "人生 K 線",
			cover: REN_SHENG_K_X_COVER,
			kind: "path",
			path: "/seer/bazi008",
		},
	];
	const tail = (mentalData.value || []).map(item => ({
		key: `api-${item.id}`,
		title: item.title,
		cover: item.cover,
		kind: "game",
		sort: item.sort,
	}));
	return [...head, ...tail].slice(0, 6);
});

function handleItem(item) {
	if (item.kind === "path" && item.path) {
		return goLink(item.path, "calc-free-fun-m");
	}
	if (item.kind === "game" && item.sort != null) {
		logEvent("home_Free_click");
		return goLink(`/dist/game/play?id=${item.sort}`, "calc-free-fun-m");
	}
}
</script>

<style lang="scss" scoped>
.free-fun-test-section {
	margin-top: 48px;
	padding: 0 24px;
	font-family: PingFang SC;

	.free-fun-test-section__title {
		padding: 0 8px;
		font-weight: 600;
		font-size: 36px;
		line-height: 60px;
		color: #333333;
	}

	.free-fun-test-section__grid {
		margin-top: 20px;
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 16px;
	}

	.free-fun-test-section__item {
		padding: 12px;
		background: #ffffff;
		border: 2px solid #ececec;
		border-radius: 12px;
		box-sizing: border-box;
		cursor: pointer;

		.cover {
			width: 100%;
			aspect-ratio: 1 / 1;
			border-radius: 8px;
			overflow: hidden;
		}

		.name {
			margin-top: 10px;
			font-weight: 500;
			font-size: 28px;
			line-height: 44px;
			color: #333333;
			text-align: center;
			display: -webkit-box;
			line-clamp: 2;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
}
</style>
